export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWI5Y2EwMWY1NzEzN2ZjOGUwZmM4OWViMWQyMjE2MDIucG5nIjs="